export default {
	white: "#fff",
	border: "#d9dfe2",
	disabled: "#959595",
	secondary: "#67a5ba",
	secondaryDark: "#67a5ba",
};
